import type { TTaskDefinitionUI } from '@bridebook/web/lib/task/task-flow-engine';
import type { IApplicationState } from '@bridebook/web/lib/types';

// Kept outside the task selectors so task definitions can use it without importing the selectors module,
// which pulls in the quiz task-definition map and would form a circular import.
export const isTodayTaskCompleted = (
  state: IApplicationState,
  taskDefinition: Pick<TTaskDefinitionUI, 'id' | 'storage'>,
) => {
  if (taskDefinition.storage === 'none') throw new Error('Invalid storage type');
  if (
    state.task.todayTasks.status === 'loaded' ||
    state.task.todayTasks.status === 'partiallyLoaded'
  ) {
    const tasksByStorage = state.task.todayTasks[taskDefinition.storage];
    if (!tasksByStorage) return false;
    return tasksByStorage[taskDefinition.id]?.done ?? false;
  }
  return false;
};
